import { Link, useNavigate } from "react-router-dom"
import { daggerNavigate } from "../../utils/navigate.util"

const SiteMenuComponent = (props) => {
  const { items } = props
  const navigate = useNavigate()

  const handleShowLoader = (e, dest) => {
    if (dest === window.location.pathname) return
    e.preventDefault()
    daggerNavigate(() => navigate(dest))
  }

  return (
    <ul>
      {items?.PageItem?.map((p) => {
        let dest
        let linkProps
        let clickHandler = (e) => handleShowLoader(e, dest)

        if (p.PageLink?.data) {
          const pageSlug = p.PageLink.data.attributes.Slug
          dest = pageSlug === "home" ? "/" : `/${pageSlug}`
        } else if (p.CaseStudyPageLink?.data) {
          dest = `/study/${p.CaseStudyPageLink.data.attributes.Slug}`
        } else if (p.ExternalLink) {
          dest = p.ExternalLink
          linkProps = { target: "_blank", rel: "noopener noreferrer" }
          clickHandler = null
        } else {
          dest = "/"
        }

        return (
          <li key={p.id}>
            <Link to={dest} {...linkProps} onClick={clickHandler}>
              {p.PageName}
            </Link>
          </li>
        )
      })}
    </ul>
  )
}

export default SiteMenuComponent
